import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import type { ConversionReport } from '../types';

/**
 * Laat zien wat bij het importeren uit Google Slides niet of alleen bij benadering is overgenomen, per slide.
 * Bewust niet weg te klikken en met de details een klik weg: er mag niets onzichtbaar verloren gaan.
 */
export default function ConversionReportNotice({ report }: { report: ConversionReport }) {
  const [open, setOpen] = useState(false);
  return (
    <div role="status" className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900">
      <p className="flex items-center gap-2 font-medium">
        <AlertTriangle className="h-4 w-4" />
        Dit resultaat wijkt af van het Google Slides-origineel
      </p>
      <p className="mt-1">
        {report.lost} onderde{report.lost === 1 ? 'el' : 'len'} niet overgenomen, {report.approximated} bij benadering overgenomen.{' '}
        <button type="button" className="underline" aria-expanded={open} onClick={() => setOpen(!open)}>
          {open ? 'Verberg details' : 'Toon details'}
        </button>
      </p>
      {open && (
        <ul className="mt-2 list-disc space-y-1 pl-5">
          {report.items.map((item, index) => (
            <li key={index}>
              Slide {item.slide}: {item.message}{' '}
              <span className="text-xs text-amber-700">({item.severity === 'lost' ? 'verloren' : item.severity === 'approximated' ? 'benaderd' : 'let op'})</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
